import { createContext, useContext } from "react";

/* Models */
import yaris from "../assets/molelos/yaris.jpg";
import yariscross from "../assets/molelos/yaris-cross.webp";
import yariscrosshybrid from "../assets/molelos/yariscrosshybrid.webp";
import corolla from "../assets/molelos/corolla.jpeg";
import corollacross from "../assets/molelos/corollacross.jpeg";
import corollacrosshibrido from "../assets/molelos/corollacrosshibrido.webp";
import hilux4x2 from "../assets/molelos/hilux4x2.jpg";
import hilux4x4 from "../assets/molelos/hilux4x4.jpg";
import hiace from "../assets/molelos/hiace.webp";


export const ConsContext = createContext();

export const useCons = () => {
  const context = useContext(ConsContext);
  if (!context) throw new Error("useCons must be used within a ConsContext");
  return context;
};

export const ConsContextProvider = ({ children }) => {
  const prices = {
    yariscross: {
      cuota: "473.340",
      valor: "41.464.000"
    },
    yariscrosshybrid: {
      cuota: "730.977",
      valor: "48.457.000"
    },
    yaris: {
      cuota: "387.460",
      valor: "34.284.000"
    },
    corolla: {
      cuota: "503.068",
      valor: "44.082.000"
    },
    corollacrosshibrido: {
      cuota: "-",
      valor: "-"
    },
    corollacross: {
      cuota: "592.940",
      valor: "51.918.000"
    },
    hilux4x2: {
      cuota: "535.216",
      valor: "49.325.000"
    },
    hilux4x4: {
      cuota: "847.778",
      valor: "59.383.000"
    },
    hiace: {
      cuota: "1.008.832",
      valor: "67.920.000"
    }
  };

  const modelos = [
    {
      id: 264,
      nombre: "Yaris Cross Nafta",
      modelo: "Toyota Yaris Cross",
      cuota: prices.yariscross.cuota,
      plan: `Financiá hasta el 70%`,
      text1: `Valor de la unidad $${prices.yariscross.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: yariscross,
      dataButton: "Plan Toyota Yaris Cross"
    },
    {
      id: 265,
      nombre: "Yaris Cross Híbrido",
      modelo: "Toyota Yaris Cross Híbrido",
      cuota: prices.yariscrosshybrid.cuota,
      plan: `Financiá hasta el 100%`,
      text1: `Valor de la unidad $${prices.yariscrosshybrid.valor}`,
      text2: "Plan 100%",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: yariscrosshybrid,
      dataButton: "Plan Toyota Yaris Cross Híbrido"
    },
    {
      id: 227,
      nombre: "Yaris",
      modelo: "Toyota Yaris",
      cuota: prices.yaris.cuota,
      plan: `Financiá hasta el 70%`,
      text1: `Valor de la unidad $${prices.yaris.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: yaris,
      dataButton: "Plan Toyota Yaris"
    },
    {
      id: 2,
      nombre: "Corolla Sedan",
      modelo: "Toyota Corolla Sedan",
      cuota: prices.corolla.cuota,
      plan: `Financiá el 70%`,
      text1: `Valor de la unidad $${prices.corolla.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: corolla,
      dataButton: "Plan Toyota Corolla Sedan"
    },
    {
      id: 245,
      nombre: "Corolla Cross XLI",
      modelo: "Toyota Corolla Cross XLI",
      cuota: prices.corollacross.cuota,
      plan: `Financiá el 70%`,
      text1: `Valor de la unidad $${prices.corollacross.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: corollacross,
      dataButton: "Plan Toyota Corolla Cross XLI"
    },
    /* {
      id: 245,
      nombre: "Corolla Cross Híbrido",
      modelo: "Toyota Corolla Cross Híbrido",
      cuota: prices.corollacrosshibrido.cuota,
      plan: `Financiá el 100%`,
      text1: `Valor de la unidad $${prices.corollacrosshibrido.valor}`,
      text2: "Plan 100%",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: corollacrosshibrido,
      dataButton: "Plan Toyota Corolla Cross Híbrido"
    }, */
    {
      id: 1,
      nombre: "Hilux 4X2",
      modelo: "Toyota Hilux 4X2",
      cuota: prices.hilux4x2.cuota,
      plan: `Financiá el 70%`,
      text1: `Valor de la unidad $${prices.hilux4x2.valor}`,
      text2: "Plan 70/30",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: hilux4x2,
      dataButton: "Plan Toyota Hilux 4X2"
    },
    {
      id: 1,
      nombre: "Hilux 4X4",
      modelo: "Toyota Hilux 4X4",
      cuota: prices.hilux4x4.cuota,
      plan: `Financiá el 100%`,
      text1: `Valor de la unidad $${prices.hilux4x4.valor}`,
      text2: "Plan 100%",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: hilux4x4,
      dataButton: "Plan Toyota Hilux 4X4"
    },
    {
      id: 224,
      nombre: "Hiace",
      modelo: "Toyota Hiace",
      cuota: prices.hiace.cuota,
      plan: `Financiá el 100%`,
      text1: `Valor de la unidad $${prices.hiace.valor}`,
      text2: "Plan 100%",
      text3: "Hasta en 84 Meses",
      text4: "Podés cancelar y adelantar cuotas",
      img: hiace,
      dataButton: "Plan Toyota Hiace"
    }
  ];

  const themeOptions = {
    acentcolor: "#eb0a1e",
    dealer: "Kansai",
    carBrand: "Toyota",
    brand: "logo.png",
    logo: "logoCons.png",
    urlHook: "https://hook.us1.make.com/copkn4amdufai1say3t1efedqqlu4pcg"
  };

  const modelsOptions = modelos.map((model) => {
    return {
      value: model.dataButton,
      text: `${model.dataButton} (Cuota $${model.cuota})`,
      disabled: model.disabled
    };
  });

  console.log(modelsOptions);

  return (
    <ConsContext.Provider
      value={{
        prices,
        modelos,
        modelsOptions,
        themeOptions
      }}
    >
      {children}
    </ConsContext.Provider>
  );
};
